

import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Component, importProvidersFrom } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';

@Component({
  selector: 'app-advanced-roi',
  standalone: false,
  templateUrl: './advanced-roi.component.html',
  styleUrl: './advanced-roi.component.scss'
})
export class AdvancedRoiComponent {
  roiForm: FormGroup;
  emi: number | null = null;
  roi: number | null = null;
  absoulateCancelledProcedure: number | null = null;
  expectedCancelledProcedure: number | null = null;
  currentPerMonthRevenue: number | null = null;
  increaseInRevenue: number | null = null;
  expectedPerMonthRevenue: number | null = null;
  costPerMonthForSpeechMEDGI: number | null = null;
  revenuePerMonth: number | null = null;

  constructor(private fb: FormBuilder) {
    this.roiForm = this.fb.group({
      possibleProcedurePerMonth: [100, [Validators.required, Validators.min(1)]],
      // tenure: [null, [Validators.required, Validators.min(1)]],
      currentCancellationPercentage:[18, [Validators.required]],
      // absoulateCancelledProcedure:[0,[Validators.required]],
      expectedCancellationPercentage:[14, [Validators.required]],
      // expectedCancelledProcedure:[0, [Validators.required]],
      costPerProcedure:[1500, [Validators.required]],
      // interestRate: [5] // Default interest rate
      
    });

    // Listen to changes for a single form control (example: "amount")
    this.roiForm.get('costPerProcedure')?.valueChanges.subscribe(value => {
      console.log('Loan Amount changed:', value);
      this.onAmountChanged(value);
    });
    // Listen to changes for a single form control (example: "amount")
    this.roiForm.get('possibleProcedurePerMonth')?.valueChanges.subscribe(value => {
      console.log('Loan Amount changed:', value);
      this.onAmountChanged(value);
    });
  }
  onAmountChanged(value: any) {
    const { possibleProcedurePerMonth, costPerProcedure, 
      currentCancellationPercentage, expectedCancellationPercentage } = this.roiForm.value;
    this.revenuePerMonth = possibleProcedurePerMonth * costPerProcedure;
  }

  calculateRoI(){
    const { possibleProcedurePerMonth, costPerProcedure, 
      currentCancellationPercentage, expectedCancellationPercentage } = this.roiForm.value;
    this.absoulateCancelledProcedure = possibleProcedurePerMonth - (possibleProcedurePerMonth*currentCancellationPercentage/100);
    this.currentPerMonthRevenue = this.absoulateCancelledProcedure * costPerProcedure;
    this.expectedCancelledProcedure = possibleProcedurePerMonth - (possibleProcedurePerMonth*expectedCancellationPercentage/100);
    this.expectedPerMonthRevenue = this.expectedCancelledProcedure * costPerProcedure;
    this.increaseInRevenue = this.expectedPerMonthRevenue - this.currentPerMonthRevenue;
    this.costPerMonthForSpeechMEDGI = possibleProcedurePerMonth * 50;
    this.roi = ((this.increaseInRevenue - this.costPerMonthForSpeechMEDGI)*100)/this.costPerMonthForSpeechMEDGI;
  }

  calculateEMI() {
    const { possibleProcedurePerMonth, tenure, interestRate } = this.roiForm.value;
    const monthlyRate = interestRate / 12 / 100;
    this.emi = (possibleProcedurePerMonth * monthlyRate * Math.pow(1 + monthlyRate, tenure)) /
               (Math.pow(1 + monthlyRate, tenure) - 1);
  }
}
